/**
 * Scriptures for lesson elder-2 (servant leadership). Text from churchofjesuschrist.org.
 */
import type { Scripture } from './scriptures';

export const elder2TrainingScripturesEn: Scripture[] = [
  {
    id: 'dc-121-34-46',
    reference: 'Doctrine and Covenants 121:34–46',
    text:
      'Behold, there are many called, but few are chosen. And why are they not chosen? Because their hearts are set so much upon the things of this world, and aspire to the honors of men, that they do not learn this one lesson— That the rights of the priesthood are inseparably connected with the powers of heaven, and that the powers of heaven cannot be controlled nor handled only upon the principles of righteousness. That they may be conferred upon us, it is true; but when we undertake to cover our sins, or to gratify our pride, our vain ambition, or to exercise control or dominion or compulsion upon the souls of the children of men, in any degree of unrighteousness, behold, the heavens withdraw themselves; the Spirit of the Lord is grieved; and when it is withdrawn, Amen to the priesthood or the authority of that man. Behold, ere he is aware, he is left unto himself, to kick against the pricks, to persecute the saints, and to fight against God. We have learned by sad experience that it is the nature and disposition of almost all men, as soon as they get a little authority, as they suppose, they will immediately begin to exercise unrighteous dominion. Hence many are called, but few are chosen. No power or influence can or ought to be maintained by virtue of the priesthood, only by persuasion, by long-suffering, by gentleness and meekness, and by love unfeigned; By kindness, and pure knowledge, which shall greatly enlarge the soul without hypocrisy, and without guile— Reproving betimes with sharpness, when moved upon by the Holy Ghost; and then showing forth afterwards an increase of love toward him whom thou hast reproved, lest he esteem thee to be his enemy; That he may know that thy faithfulness is stronger than the cords of death. Let thy bowels also be full of charity towards all men, and to the household of faith, and let virtue garnish thy thoughts unceasingly; then shall thy confidence wax strong in the presence of God; and the doctrine of the priesthood shall distil upon thy soul as the dews from heaven. The Holy Ghost shall be thy constant companion, and thy scepter an unchanging scepter of righteousness and truth; and thy dominion shall be an everlasting dominion, and without compulsory means it shall flow unto thee forever and ever.',
    verses: [
      {
        verse: 34,
        text: 'Behold, there are many called, but few are chosen. And why are they not chosen?',
      },
      {
        verse: 35,
        text: 'Because their hearts are set so much upon the things of this world, and aspire to the honors of men, that they do not learn this one lesson—',
      },
      {
        verse: 36,
        text: 'That the rights of the priesthood are inseparably connected with the powers of heaven, and that the powers of heaven cannot be controlled nor handled only upon the principles of righteousness.',
      },
      {
        verse: 37,
        text: 'That they may be conferred upon us, it is true; but when we undertake to cover our sins, or to gratify our pride, our vain ambition, or to exercise control or dominion or compulsion upon the souls of the children of men, in any degree of unrighteousness, behold, the heavens withdraw themselves; the Spirit of the Lord is grieved; and when it is withdrawn, Amen to the priesthood or the authority of that man.',
      },
      {
        verse: 38,
        text: 'Behold, ere he is aware, he is left unto himself, to kick against the pricks, to persecute the saints, and to fight against God.',
      },
      {
        verse: 39,
        text: 'We have learned by sad experience that it is the nature and disposition of almost all men, as soon as they get a little authority, as they suppose, they will immediately begin to exercise unrighteous dominion.',
      },
      {
        verse: 40,
        text: 'Hence many are called, but few are chosen.',
      },
      {
        verse: 41,
        text: 'No power or influence can or ought to be maintained by virtue of the priesthood, only by persuasion, by long-suffering, by gentleness and meekness, and by love unfeigned;',
      },
      {
        verse: 42,
        text: 'By kindness, and pure knowledge, which shall greatly enlarge the soul without hypocrisy, and without guile—',
      },
      {
        verse: 43,
        text: 'Reproving betimes with sharpness, when moved upon by the Holy Ghost; and then showing forth afterwards an increase of love toward him whom thou hast reproved, lest he esteem thee to be his enemy;',
      },
      {
        verse: 44,
        text: 'That he may know that thy faithfulness is stronger than the cords of death.',
      },
      {
        verse: 45,
        text: 'Let thy bowels also be full of charity towards all men, and to the household of faith, and let virtue garnish thy thoughts unceasingly; then shall thy confidence wax strong in the presence of God; and the doctrine of the priesthood shall distil upon thy soul as the dews from heaven.',
      },
      {
        verse: 46,
        text: 'The Holy Ghost shall be thy constant companion, and thy scepter an unchanging scepter of righteousness and truth; and thy dominion shall be an everlasting dominion, and without compulsory means it shall flow unto thee forever and ever.',
      },
    ],
    context: 'Priesthood power only by righteousness; persuasion, charity, and the Holy Ghost.',
  },
  {
    id: 'john-13-14-15',
    reference: 'John 13:14–15',
    text:
      "If I then, your Lord and Master, have washed your feet; ye also ought to wash one another's feet. For I have given you an example, that ye should do as I have done to you.",
    verses: [
      {
        verse: 14,
        text: "If I then, your Lord and Master, have washed your feet; ye also ought to wash one another's feet.",
      },
      {
        verse: 15,
        text: 'For I have given you an example, that ye should do as I have done to you.',
      },
    ],
    context: 'Christ teaches service by the example of washing the feet.',
  },
  {
    id: 'dc-107-99-100',
    reference: 'Doctrine and Covenants 107:99–100',
    text:
      'Wherefore, now let every man learn his duty, and to act in the office in which he is appointed, in all diligence. He that is slothful shall not be counted worthy to stand, and he that learns not his duty and shows himself not approved shall not be counted worthy to stand. Even so. Amen.',
    verses: [
      {
        verse: 99,
        text: 'Wherefore, now let every man learn his duty, and to act in the office in which he is appointed, in all diligence.',
      },
      {
        verse: 100,
        text: 'He that is slothful shall not be counted worthy to stand, and he that learns not his duty and shows himself not approved shall not be counted worthy to stand. Even so. Amen.',
      },
    ],
    context: 'Learn duty and serve diligently in the appointed office.',
  },
  {
    id: 'alma-17-11',
    reference: 'Alma 17:11',
    text:
      'And the Lord said unto them also: Go forth among the Lamanites, thy brethren, and establish my word; yet ye shall be patient in long-suffering and afflictions, that ye may show forth good examples unto them in me, and I will make an instrument of thee in my hands unto the salvation of many souls.',
    verses: [
      {
        verse: 11,
        text: 'And the Lord said unto them also: Go forth among the Lamanites, thy brethren, and establish my word; yet ye shall be patient in long-suffering and afflictions, that ye may show forth good examples unto them in me, and I will make an instrument of thee in my hands unto the salvation of many souls.',
      },
    ],
    context: 'Patience and good example in missionary work among the Lamanites.',
  },
  {
    id: 'dc-58-27',
    reference: 'Doctrine and Covenants 58:27',
    text:
      'Verily I say, men should be anxiously engaged in a good cause, and do many things of their own free will, and bring to pass much righteousness;',
    verses: [
      {
        verse: 27,
        text: 'Verily I say, men should be anxiously engaged in a good cause, and do many things of their own free will, and bring to pass much righteousness;',
      },
    ],
    context: 'Agency and initiative in doing good without waiting for every command.',
  },
];
